var map = {
	"./ar.json": "../assets/i18n/ar.json",
	"./be.json": "../assets/i18n/be.json",
	"./cs.json": "../assets/i18n/cs.json",
	"./de.json": "../assets/i18n/de.json",
	"./en.json": "../assets/i18n/en.json",
	"./es.json": "../assets/i18n/es.json",
	"./fa.json": "../assets/i18n/fa.json",
	"./fi.json": "../assets/i18n/fi.json",
	"./fr.json": "../assets/i18n/fr.json",
	"./hi.json": "../assets/i18n/hi.json",
	"./it.json": "../assets/i18n/it.json",
	"./ja.json": "../assets/i18n/ja.json",
	"./nl.json": "../assets/i18n/nl.json",
	"./pl.json": "../assets/i18n/pl.json",
	"./pt.json": "../assets/i18n/pt.json",
	"./ru.json": "../assets/i18n/ru.json",
	"./sa.json": "../assets/i18n/sa.json",
	"./tr.json": "../assets/i18n/tr.json",
	"./uk.json": "../assets/i18n/uk.json",
	"./vi.json": "../assets/i18n/vi.json",
	"./zh.json": "../assets/i18n/zh.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../assets/i18n sync recursive ^\\.\\/.*\\.json$";